import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2017. Plesk International GmbH. All rights reserved.
import { Component } from 'react';
import PropTypes from 'prop-types';

var ScrollDirection =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollDirection, _Component);

  function ScrollDirection() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollDirection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollDirection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      direction: 'up'
    });

    _defineProperty(_assertThisInitialized(_this), "prevScrollTop", 0);

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (e) {
      var scrollTop = e.target.scrollTop;
      var direction = scrollTop > _this.prevScrollTop ? 'down' : 'up';
      _this.prevScrollTop = scrollTop;

      _this.setState({
        direction: direction
      });
    });

    return _this;
  }

  _createClass(ScrollDirection, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        direction: this.state.direction,
        handleScroll: this.handleScroll
      });
    }
  }]);

  return ScrollDirection;
}(Component);

ScrollDirection.propTypes = {
  children: PropTypes.func.isRequired
};
export default ScrollDirection;